import React, { Component } from 'react'
import { selectors, actions } from '../sagas/reservation/index'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import OrderRow from './OrderRow'
import './OrderIndex.sass'

class Order extends Component {
  render () {
    return (
      <div>
        <OrderRow
          reservation={this.props.reservation}
          customer={this.props.customer}
        />
      </div>
    )
  }
};

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch)

const mapStateToProps = (store, ownProps) => ({
  store: selectors.reservations_store(),
  customer: selectors.customer(ownProps.reservation)
})

export default (connect(mapStateToProps, mapDispatchToProps)(Order))



// WEBPACK FOOTER //
// ./src/Reservations/Order.jsx